export default function authHeader() {
  let token = localStorage.getItem('P_JWT');

  if (token) {
    return {
      'Authorization': `bearer ${token}`,
      'Content-Type': 'application/json'
    }
  } else {
    return {'Content-Type': 'application/json'};
  }
}
